import React, { PropTypes } from 'react';

import Button from '../../../Button';
import DateRangePicker from '../../../../containers/DateRangePicker';
import Placepicker from '../../../Placepicker/Placepicker.react';

import { button, header, tagline, title as titleStyle } from './styles.module.css';

const SearchHeader = ({ onDateChange, onLocationChange, onSubmit, title, values }) => (
  <header className={header} id="search-header">
    <div className={`info ${!values.minDate && !values.maxDate ? 'no-dates' : 'has-dates'}`}>
      <h1 className={titleStyle}>{title}</h1>
      <div className="placepickerContainer">
        <Placepicker
          name="location"
          className="placepicker"
          onChange={onLocationChange}
          placeholder="Enter location"
          value={values.location || values.defaultLocation}
        />
        <DateRangePicker
          onChange={onDateChange}
          startDate={values.minDate}
          endDate={values.maxDate}
          customCloseIcon={<span />}
          showClearDates={false}
        />
        <Button primary onClick={onSubmit} className={button}>
          {'Show events'}
        </Button>
      </div>
    </div>
    <p className={tagline}>
      {'Search and book the best events, find your next challenge and get inspired.'}
    </p>
  </header>
);

SearchHeader.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  onLocationChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  values: PropTypes.shape().isRequired,
};

export default SearchHeader;



// WEBPACK FOOTER //
// ./app/src/components/Discovery/components/SearchHeader/component.jsx